import { $, $$ } from 'utils/dom';
import { APILazerLoader } from 'modules/lazer-loader';
import { getPlyr, Video } from 'modules/video/create-plyr';
import { ConsentOverlay, handleEmbed } from './consent-overlay';
import '@3pc/consent-overlay/lib/style/consent-overlay.scss';

const createPlayer = async (api, container) => {
  const videoParent = container.parentElement;
  const pl = new Video(api, container, {});
  const player = await pl.create();

  // bind plyr instance to parent element, so we can destroy it later, via cookiebanner/conset-overlay
  videoParent.plyr = player;

  return player;
};

export const observe = targets => {
  new APILazerLoader({
    targets,
    config: {
      rootMargin: '50px 0px',
      threshold: 0.01,
    },
    cb: (api, { target }) => createPlayer(api, target),
    loadAPI: () => getPlyr(),
  }).init();
};

const overlays = $$('[data-consent-type]');
overlays.length &&
  overlays.forEach(overlay => {
    new ConsentOverlay({
      container: overlay,
      nameSpace: 'arsenal',
      onActivation: async (container, consentType, consentSubtype) => {
        // init plyr for vimeo and youtube
        if (consentSubtype === 'vimeo' || consentSubtype === 'youtube') {
          const $video = $('.plyr__video-embed', container);

          if (!$video) return;

          const plyr = await getPlyr();
          return createPlayer(plyr, $video);
        }

        // init iframe
        if (consentSubtype === 'iframe') {
          return handleEmbed(container, true);
        }
      },
      onDeactivation: (container, _, consentSubtype) => {
        // destroy plyr for vimeo and youtube
        if (consentSubtype === 'vimeo' || consentSubtype === 'youtube') {
          const videoContent = $('.consent-overlay__content', container);
          return videoContent.plyr.destroy();
        }

        // destroy iframe
        if (consentSubtype === 'iframe') {
          return handleEmbed(container, false);
        }
      },
    }).init();
  });
